export const PUBLIC_URL = process.env.PUBLIC_URL || ''

if (typeof String.prototype.startsWith !== 'function') {
    String.prototype.startsWith = function(prefix) {
        return this.slice(0, prefix.length) === prefix
    }
}

if (typeof String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function(suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1
    }
}

export const ROUTER_BASENAME = (() => {

    if (!PUBLIC_URL) {
        return ''
    } else if (/^(\/|https?:\/\/)/.test(PUBLIC_URL)) {
        const link = document.createElement('a') as HTMLAnchorElement
        link.href = PUBLIC_URL
        const path = link.pathname
        return path.endsWith('/') ? path.substr(0, path.length - 1) : path
    } else {
        // tslint:disable-next-line
        console.warn(new Error(`Invalidated PUBLIC_URL ${JSON.stringify(PUBLIC_URL)}`))
        return ''
    }

})()

// 自动跳到相应的子路径
if (typeof location === 'object' && !(location.pathname.startsWith(ROUTER_BASENAME))) {
    location.assign(ROUTER_BASENAME)
}



// WEBPACK FOOTER //
// ./src/services/path.ts